import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { browserHistory } from 'react-router';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import 'yup-phone';

import {
  ModalOverlay,
  ResponsiveContent,
  ModalCloseHeader
} from '@evdy/web-core/dist/components/shared/Modal2020';
import TextInput from '../TextInput';

import { webCommunityOperations } from '@evdy/web-redux/dist/lib/webCommunity';

import styles from './AddPhoneModal.module.scss';

const { savePhone } = webCommunityOperations;

const {
  'add-phone-modal': addPhoneModalClass,
  'add-phone-body': addPhoneBodyClass,
  inputs: inputsClass,
  'button-container': buttonContainerClass,
  'privacy-policy': privacyPolicyClass,
  'privacy-link': privacyLink
} = styles;

const AddPhoneModal = ({ baseRoute, closeModal }) => {
  const dispatch = useDispatch();
  const { user: loggedInUser } = useSelector(({ webCommunity, authUser }) => ({
    user: authUser?.data
  }));

  const { phone, meta } = loggedInUser || {};
  const { posterShellPhone } = meta || {};

  const AddPhoneFormSchema = Yup.object().shape({
    phone: Yup.string()
      .phone('US', true, 'Please enter a valid phone number.')
      .required('Phone is required!')
  });

  const onSubmit = ({ phone }) => {
    const strippedPhone = phone?.replace(/\D+/g, '');
    dispatch(savePhone({ phone: strippedPhone }));
  };

  // if phone is saved send then finish flow
  useEffect(() => {
    if (!!phone || !!posterShellPhone) {
      // finish message post flow
      browserHistory.push({ pathname: `${baseRoute}/condolence/message-posted` });
    }
  }, [baseRoute, phone, posterShellPhone]);

  const PrivacyPolicySection = () => (
    <div className={privacyPolicyClass}>
      By continuing, you agree to our{' '}
      <a href="/privacy" rel="noreferrer noopener" target="_blank" className={privacyLink}>
        Privacy Policy
      </a>{' '}
      and{' '}
      <a href="/terms" rel="noreferrer noopener" target="_blank" className={privacyLink}>
        Terms & Conditions
      </a>
    </div>
  );

  return (
    <ModalOverlay modalVisible {...{ closeModal }} customClass={addPhoneModalClass}>
      <ResponsiveContent>
        <ModalCloseHeader {...{ closeModal }} />
        <div className={addPhoneBodyClass}>
          <h3>Thank you for your kind words</h3>
          <p>
            Add your phone number so we can notify you when any friends & family respond to the
            message you’ve shared.
          </p>
          <Formik
            initialValues={{ phone: '' }}
            validationSchema={AddPhoneFormSchema}
            onSubmit={onSubmit}
          >
            <Form>
              <div className={inputsClass}>
                <TextInput type="tel" label="Phone" name="phone" placeholder="800-555-1234" />
              </div>
              <div className={buttonContainerClass}>
                <button type="submit">Save</button>
              </div>
            </Form>
          </Formik>
          <PrivacyPolicySection />
        </div>
      </ResponsiveContent>
    </ModalOverlay>
  );
};

export default AddPhoneModal;
